/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*
*/
define([
	'dashboard-analytics/lib/@waca/core-client/js/core-client/ui/core/Class',
	'dashboard-analytics/visualizations/renderer/sequence/DataTask'
], function (Class, DataTask) {
	'use strict';

	const DataTaskOverride = DataTask.extend({
		init: function(options, moduleOptions) {
			DataTaskOverride.inherited('init', this, arguments);

			this._queryResults = moduleOptions.queryResults;
		},

		process: function(renderContext) {
			const view = this.getRenderState().getCurrentContextData('visView');

			if (!view || this._isStepComplete(renderContext, 'data')) {
				return Promise.resolve(renderContext);
			}

			view.preDataReady();

			return Promise.resolve()
				.then(() => {
					if (this._queryResults) {
						view.setRenderingNewData(true);
						this._completeStep(renderContext, 'data', this._queryResults);
					}
					return renderContext;
				});
		}
	});

	return DataTaskOverride;
});
